import { render, staticRenderFns } from "./ItemNameEditor.vue?vue&type=template&id=654561c6&scoped=true&"
import script from "./ItemNameEditor.vue?vue&type=script&lang=js&"
export * from "./ItemNameEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654561c6",
  null
  
)

export default component.exports